import { render } from "./Category.vue?vue&type=template&id=ac3fab90&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ac3fab90"

export default script